window.initMap = function () {
    const els = document.getElementsByClassName('uq-map-element');

    for (let map of els) {
        if (!!map) {
            let lat = parseFloat(map.dataset.lat);
            let lng = parseFloat(map.dataset.lng);
            let zoom = parseFloat(map.dataset.zoom);
            let pointers = JSON.parse(map.dataset.pointers);
            let image = map.dataset.image;

            map = new google.maps.Map(map, {
                center: {lat: lat, lng: lng},
                zoom: zoom
            });

            if (pointers.length > 0) {
                for (let point in pointers) {
                    let pointerLat = parseFloat(pointers[point]['lat']);
                    let pointerLng = parseFloat(pointers[point]['lng']);

                    new google.maps.Marker({
                        position: {lat: pointerLat, lng: pointerLng},
                        map,
                        icon: image,
                    });
                }
            } else {
                new google.maps.Marker({
                    position: {lat: lat, lng: lng},
                    map,
                });
            }
        }
    }
}
